var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 151,
    viewBox: "0 0 98 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3595 88.099V78.3125H9.7865C7.09521 78.3125 4.79212 77.3551 2.87723 75.4402C0.962339 73.5253 0.00326217 71.2206 0 68.526V9.80701C0 7.11572 0.959077 4.81263 2.87723 2.89774C4.79539 0.982847 7.09847 0.02377 9.7865 0.0205078H88.0785C90.7698 0.0205078 93.0745 0.979585 94.9927 2.89774C96.9108 4.81589 97.8683 7.11898 97.865 9.80701V68.526C97.865 71.2173 96.9076 73.522 94.9927 75.4402C93.0778 77.3583 90.773 78.3158 88.0785 78.3125H68.5055V88.099H29.3595ZM9.7865 68.526H88.0785V9.80701H9.7865V68.526Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7013 110.787V112.933H42.1913V131H39.5523V112.933H34.0133V110.787H47.7013ZM56.8658 128.564L61.7958 115.108H64.6088L58.3738 131H55.2998L49.0648 115.108H51.9068L56.8658 128.564Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon12);
export default __webpack_public_path__ + "static/media/icon12.7e98f42ab0f47623ebcb72707425a3fa.svg";
export { ForwardRef as ReactComponent };